import React, { useState } from "react";
import "./ContactForm.css";
import { FaCheck, FaEnvelope } from "react-icons/fa";
import { contactPageData } from "../../portfolio.js";

const GOOGLE_FORM_ACTION =
  "https://docs.google.com/forms/d/e/1FAIpQLScsnu5K3BUAxlnI_Kc-ofCnVOmhXsvcc9Qwpv6AykV0PvRP4A/formResponse";
const GOOGLE_FORM_NAME_ID = "entry.1032955691";
const GOOGLE_FORM_EMAIL_ID = "entry.710273651";
const GOOGLE_FORM_MESSAGE_ID = "entry.134231363";

const ContactForm = ({ theme }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState(null);

  const handleSubmit = () => {
    // Form submits via standard POST to hidden iframe (handled by the <form> element)
    // This callback runs after the form is submitted
    setStatus("success");
    setFormData({ name: "", email: "", message: "" });
    setTimeout(() => setStatus(null), 6000);
  };

  const emailAddr = contactPageData.emailSection["subtitle"];

  return (
    <div className="contact-form-div">
      {/* Hidden iframe receives the Google Forms response */}
      <iframe
        name="hidden_iframe"
        title="hidden_iframe"
        style={{ display: "none" }}
        onLoad={() => {
          // Only trigger on actual form submission, not initial mount
          if (status === "submitting") {
            handleSubmit();
          }
        }}
      />
      <form
        action={GOOGLE_FORM_ACTION}
        method="POST"
        target="hidden_iframe"
        onSubmit={() => setStatus("submitting")}
        className="contact-form"
      >
        <div className="form-group">
          <input
            type="text"
            name={GOOGLE_FORM_NAME_ID}
            placeholder="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="email"
            name={GOOGLE_FORM_EMAIL_ID}
            placeholder="Email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <textarea
            name={GOOGLE_FORM_MESSAGE_ID}
            placeholder="Message"
            value={formData.message}
            onChange={(e) =>
              setFormData({ ...formData, message: e.target.value })
            }
            required
          />
        </div>
        <div className="form-submit-container">
          <button
            type="submit"
            className="custom-button"
            style={{
              color: theme.body,
              backgroundColor: theme.text,
              border: "solid 1px " + theme.text,
            }}
          >
            Submit
          </button>
          {status === "success" && (
            <div className="success-message">
              <FaCheck className="check-icon" /> Message sent!
            </div>
          )}
        </div>
      </form>
      <div className="manual-email-section">
        <a
          href={"mailto:" + emailAddr}
          className="manual-email-link"
          style={{ color: theme.secondaryText }}
        >
          <FaEnvelope /> {emailAddr}
        </a>
      </div>
    </div>
  );
};

export default ContactForm;
